import { api } from "../client";
import { ReportExecute } from "../schema";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<ReportExecute>;
// type ApiRequestConfigMutate = ConfigMutate<ReportExecute>;

export const getReportExecute = async (config?: ApiRequestConfig) => {
  return api.get<ReportExecute>("odbc_reports/execute", config);
};

// TODO: zlecenie na dostosowanie do Next.js - aktualny błąd `Only absolute URLs are supported`
